import { StyleSheet } from 'react-native';
import { COLORS } from '../../../../../config/colors';
import { horizontalSize } from '../../../../../functions/responsive';
import { THEME_COLORS } from '../../../../../theme/constants/themeColors';
import { StyleHelpers } from '../../../../../constants/style-helpers';
import { THEME_STYLES } from '../../../../../theme/constants/themeStyles';

export default StyleSheet.create({
  cont_card: {
    backgroundColor: COLORS.whiteColor,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: COLORS.blackColor,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  btnCont: {
    ...THEME_STYLES.item,
    backgroundColor: THEME_COLORS.buttonBgColor,
    borderRadius: 8,
    padding: 4,
    // width: horizontalSize(35),
    width: '100%',
    justifyContent: "center",
  },
  rowStyle: {
    flexDirection: 'row',
    alignItems: 'center'
  }
});
